export default __webpack_public_path__ + "static/media/evoUSDT.f34231e7.svg";